import React from "react";
import "./CartoonAlertPopup.css";

import errorCartoon from "./error.png";
import successCartoon from "./sucess.png";


const CartoonAlertPopup=({
type="success",
message,
onClose
})=>{


const isError=type==="error";


return(

<div className="cartoon-overlay">


<div className={`cartoon-popup ${isError?"error-popup":"success-popup"}`}>


<div className="cartoon-image-box">

<img
src={
isError
?
errorCartoon
:
successCartoon
}
alt="cartoon alert"
/>

</div>



<div className="cartoon-message-box">


<div className="speech-bubble">


<h2>

{
isError
?
"😟 Oh no!"
:
"🎉 Great!"
}

</h2>


<p>
"{message}"
</p>


</div>



<button
className={
isError
?
"retry-btn"
:
"continue-btn"
}
onClick={onClose}
>

{
isError
?
"Try Again"
:
"Continue"
}

</button>


</div>


</div>


</div>

);

};


export default CartoonAlertPopup;


// import React from "react";
// import "./CartoonAlertPopup.css";

// import errorCartoon from "./error.png";
// import successCartoon from "./sucess.png"; 


// const CartoonAlertPopup = ({
// type="success",
// message,
// onClose
// })=>{


// const isError=type==="error";


// return(

// <div className="cartoon-overlay">


// <div
// className={`cartoon-popup ${isError?"error-popup":"success-popup"}`}
// >


// <div className="cartoon-image-box">

// <img
// src={
// isError
// ?
// errorCartoon
// :
// successCartoon
// }
// alt="alert cartoon"
// />

// </div>



// <div className="cartoon-message-box">


// <h2>

// {
// isError
// ?
// "Oops! Something went wrong"
// :
// "Account Created Successfully"
// }

// </h2>


// <p>
// {message}
// </p>



// <button
// className={
// isError
// ?
// "retry-btn"
// :
// "continue-btn"
// }
// onClick={onClose}
// >

// {
// isError
// ?
// "Try Again"
// :
// "Continue"
// }

// </button>


// </div>


// </div>


// </div>

// );

// };


// export default CartoonAlertPopup;